<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div v-if="$store.state.review.isList">
        <div class="titlePart">审核通过</div>
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding: 20px 30px 0"
        >
          <el-form-item label="企业名称">
            <el-input
              v-model="searchForm.enterpriseName"
              placeholder="请输入"
              style="width: 200px"
              suffix-icon="el-icon-search"
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item label="证件代码">
            <el-input
              v-model="searchForm.enterpriseCode"
              placeholder="请输入"
              style="width: 200px"
              suffix-icon="el-icon-search"
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item label="证件代码类型">
            <el-select
              v-model="searchForm.zjType"
              placeholder="请选择"
              style="width: 200px"
              @change="handleChange"
              clearable
            >
              <el-option
                v-for="item in cardOption"
                :key="item.value"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="padding: 0">
          <el-table
            :data="tableData"
            style="width: 100%;"
          >
            <el-table-column
              prop="zjName"
              label="证照类型"
              width="200"
            />
            <el-table-column
              prop="enterpriseCode"
              label="证件代码"
              width="200"
            />
            <el-table-column
              prop="enterpriseName"
              label="企业名称"
              width="300"
            />
            <el-table-column
              prop="legalPerson"
              label="法人"
            />
            <el-table-column
              prop="operatorName"
              label="经办人"
            />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDetail(scope.row)"
                >查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-else>
        <review-detail />
      </div>
    </div>
  </div>
</template>

<script>
import ReviewDetail from "./ReviewDetail";
import TopMessage from "@/components/TopMessage";
import { queryAuth, selectByCode } from "../../api/review";
export default {
  components: { ReviewDetail, TopMessage },
  data () {
    return {
      searchForm: {
        enterpriseName: "",
        zjType: "",
        enterpriseCode: "",
        examineStatus: 1,
      },
      cardOption: [],
      tableData: []
    }
  },
  created () {
    this.getList();
    this.getselectByCode()
  },
  methods: {
    getselectByCode () {
      let code = '00401'
      selectByCode(code).then(res => {
        if (res.data.code == 200) {
          this.cardOption = res.data.data
        }
      })
    },
    getList () {
      queryAuth(this.sendParam(this.searchForm)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.tableData = res.data;
        }
      });
    },
    handleDetail (row) {
      this.$store.commit("setReviewInfo", row);
      this.$store.commit("setIsList", false);
    },
    // 翻译
    typeFormat (row) {
      return row.legalPersonIdType && this.cardOption.find(x => x.value === row.legalPersonIdType).label;
    },
    // 改变值
    handleChange () {
      this.getList();
    }
  }
}
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  min-height: 740px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
  }
  .el-divider {
    background-color: #f3f4f9;
  }
}
/deep/.el-table {
  thead tr th {
    background: #f3f4f9;
  }
  thead tr th:first-child div {
    padding-left: 30px;
  }
  tbody tr td:first-child div {
    padding-left: 30px;
  }
}
</style>
